import { render, staticRenderFns } from "./BuyMinutes.vue?vue&type=template&id=72c8c950&scoped=true"
import script from "./BuyMinutes.vue?vue&type=script&lang=js"
export * from "./BuyMinutes.vue?vue&type=script&lang=js"
import style0 from "./BuyMinutes.vue?vue&type=style&index=0&id=72c8c950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c8c950",
  null
  
)

export default component.exports